import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";
import {PageLoader} from "../../components/Loader";
import _ from "lodash";
import ErrorNotFound from "../ErrorNotFound";
import ContentPage from "./ContentPage";
import {fetchFacetteByUri,resetFacette} from "../../../creators/facette";

class FacettesUri extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            //currentCategory : ""
        };

        this.facetteUri = _.get(this.props,"match.params.categorySlug");
        if(this.facetteUri && this.facetteUri !== "" && !this.facetteUri.endsWith("/")){
            this.facetteUri = `${this.facetteUri}/`;
        }
        this.props.resetFacette();
        this.props.fetchFacetteByUri(encodeURIComponent(this.facetteUri));

    }

    fetchLastCategory(){
        let categoryId = null;
        let currentCat = this.facetteUri;
        currentCat = currentCat.split('/').filter(item => item).pop();
        let cat = _.get(this.props.facette, "categoriesValues") || [];
        cat.forEach(item => {
            if(currentCat.includes(item.value.slug)){
                categoryId = item.value._id;
            }
        });
        return categoryId
    }

    fetchCategories(){
        let categories = _.get(this.props.facette, "categoriesValues") || [];
        categories = [...categories];
        let cat = [];
        categories.forEach(item =>{
            //cat.push(item.category._id);
            cat.push(item.value._id);
        });

        return cat || [];
    }


    componentDidUpdate(prevProps, prevState, snapshot) {
        if(_.get(prevProps,"location.pathname") !== _.get(this.props,"location.pathname")){
            this.facetteUri = _.get(this.props,"match.params.categorySlug");
            if(this.facetteUri && this.facetteUri !== "" && !this.facetteUri.endsWith("/")){
                this.facetteUri = `${this.facetteUri}/`;
            }
            this.props.resetFacette();
            this.props.fetchFacetteByUri(encodeURIComponent(this.facetteUri));
        }
    }


    render() {

        return !this.props.facetteInitialized && this.props.facetteError.statusCode !== 404 ? (
            <div id="facettes">
                <div className="container">
                    <div className="card big">
                        <PageLoader/>
                    </div>
                </div>
            </div>
            )
        : this.props.facetteError.statusCode === 404 ? (
            <ErrorNotFound />
        )
        : (
            <ContentPage location={this.props.location} match={this.props.match} currentCategory={this.fetchLastCategory()} categories={this.fetchCategories()} facette={this.props.facette} />
        )
    }
}


const mapStateToProps = (state) => {
    return {
        facette : state.facette.data,
        facetteError : state.facette.error,
        facetteInitialized : state.facette.initialized,
        facetteLoading : state.facette.loading,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchFacetteByUri,
    resetFacette
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(FacettesUri);
